module.exports = __webpack_public_path__ + "static/logo-e28cbc3d8ce542e0cc99c17e8ebdef7a.png";